var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#072F3D",
    d: "M14.3 5.99a.375.375 0 0 0-.531 0L5.578 14.18a.375.375 0 0 0 0 .53l3.71 3.712a.375.375 0 0 0 .531 0l8.188-8.188a.374.374 0 0 0 0-.53L14.3 5.99zM4.822 15.6a.375.375 0 0 0-.63.178l-1.129 4.707a.376.376 0 0 0 .452.452l4.704-1.125a.375.375 0 0 0 .178-.63L4.822 15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38BCEE",
    d: "M20.4 5.193L18.808 3.6a1.875 1.875 0 0 0-2.65 0l-1.063 1.063a.375.375 0 0 0 0 .53l3.713 3.712a.375.375 0 0 0 .53 0L20.4 7.84c.73-.732.73-1.916 0-2.648z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEdit);
export default __webpack_public_path__ + "static/media/icons-edit.197450caea1f970795d84fb30bde445b.svg";
export { ForwardRef as ReactComponent };